.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.blocklist-rules-text {
  color: var(--body-text-arrows-400);
}

.less-margin-top {
  margin-top: calc(var(--spacer)* -2);
}

.pl-0 {
  padding-left: 0px;
}

.padding-top-after-info-text {
  padding-top: calc(var(--spacer)* 2);
}

.extra-margin {
  margin-left: 27px;
}

.less-margin {
  margin-left: -27px;
}

.form-section {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: calc(var(--spacer) * 2.5);
  flex-direction: column;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

gz-form-field {
  &#policy-panel-recurrence-run-per,
  &#policy-panel-recurrence-run-every,  &#policy-panel-recurrence-weekdays-run-every {
    --margin-bottom-wrapper: var(--spacer);
  }
}

.field-with-icon-row {
  display: flex;

  div {
    flex: 0 0 300px;
    display: flex;
  }

  gz-icon {
    margin-bottom: 15px;
  }

  gz-icon + gz-icon {
    margin-left: 5px;
    margin-bottom: 18px;
  }
}

gz-text {
  max-width: 880px;
}
